import TinyMce from './TinyMce.vue'

export default TinyMce